import { useEffect, useState } from 'react';
import axios from 'axios';
import { RDatePicker } from '../ReactComponents/RDatePicker';
import moment from 'moment';
import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';

const DynamicAdd = props => {
    const { register, watch, setValue, handleSubmit, control, reset, formState: { errors } } = useForm();
    const [saving, setSaving] = useState(false);

    let prom = new Promise(async(resolve, reject) => {
        var d = {};
        for (var x = 0; x < props.input?.length; x++) {
            var input = props.input[x];
            if (input.type == 'select') {
                if (Array.isArray(input.options))
                    d = { ...d, [x]: input.options }
                else
                    d = { ...d, [x]: await input.options() }
            }
        }
        resolve(d);
    });

    const [optionsVal, setOptionsVal] = useState({});
    const [ loading, setLoading ] = useState(true);

    useEffect(_ => {
        prom.then(d => {
            setOptionsVal(d);
        }).finally(_ => setLoading(false));
    }, [])
    const [autoFills, setAutoFills] = useState({});

    useEffect(_ => {
        if (props.modalOpen) {
            reset();
            setAutoFills(o => {
                var oo = {};
                Object.keys(o).forEach(k => {
                    oo = {...o, [k]: ""}
                })
                return oo;
            })
        }
    }, [props.modalOpen])

    const onSave = async (data) => {
        if (saving == false) {
            setSaving(true);

            var f = new FormData();
            Object.keys(data).forEach(k => f.append(k, data[k] ?? ""))

            await axios.post(props.url, f, {withCredentials:true}).then(_ => {
                reset();
                if (props.setModal) props.setModal(false);
                if (props.refreshTable) props.refreshTable();
            }).catch(e => alert(e))
            setSaving(false);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (props.autoFills?.length > 0) {
                var af = props.autoFills;
                for (var counter = 0; counter < af.length; counter++){
                    if (name == af[counter].From) {
                        var currAf = af[counter];
                        var newValue = currAf.Func(value[name]);
                        setValue(currAf.To, newValue);
                        setAutoFills(oaf => ({ ...oaf, [currAf.To]: newValue }))
                    }
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    if(props.input?.filter(i=>i.type==="select").length > 0 && loading) return <>Loading options..</>
    return <>
        {
            saving ? <>
                Saving data...
            </> 
                : <form onSubmit={handleSubmit(onSave)}>
                    {
                        props.input ?
                            props.input.map((i, ii) => {
                                var _afObj = props.autoFills?.length > 0 ?
                                    props.autoFills.filter(af => af.To == i.name)
                                    : null;
                                var el = <div>
                                    {i.label}
                                    {
                                        _afObj?.length > 0 ?
                                            <>
                                                <input type={i.type ?? "text"}
                                                    onChange={e => {
                                                        var v = e.target.value;
                                                        setValue(i.name, v);
                                                        setAutoFills(af => ({...af, [i.name]: v }) )
                                                    }} required={i.props?.required ? true : false}
                                                    value={autoFills[i.name]} className="form-control" autocomplete="off" />
                                            </>
                                            :
                                            <> 
                                                <input type={i.type ?? "text"}
                                                    {...register(i.name, { ...i.props })} className="form-control" autocomplete="off" />
                                            </>

                                    }
                                </div>;

                                switch (i.type) {
                                    case "textarea":
                                        el = <>
                                            {i.label} <textarea {...register(i.name, { ...i.props })} className="form-control" autocomplete="off" />
                                        </>;
                                        break;
                                    case "select":
                                        el = <>
                                            {i.label}
                                            <select className="form-select" {...register(i.name)}>
                                                {
                                                    optionsVal[ii]?.map((o, ik) => <option key={ik} value={o.value}>{o.label}</option>)
                                                }
                                            </select>
                                        </>
                                        break;
                                    case "date":
                                        el = <>{i.label}
                                            <Controller
                                                name={i.name}
                                                control={control}
                                                rules={i.props}
                                                render={({ field: { onChange, value } }) => {
                                                    return (
                                                        <RDatePicker
                                                            {...i.controlProps}
                                                            selectedDate={value}
                                                            onChange={e => onChange(moment(e).isValid() ? moment(e).format("MM/DD/YYYY") : "")}
                                                        />
                                                    )
                                                }
                                                }
                                            />
                                        </>
                                        break;
                                    case "checkbox":
                                        el = <div className="form-check mt-2">
                                            <input {...register(i.name)} className="form-check-input" type="checkbox" id={`check-${i.name}`} />
                                            <label className="form-check-label" htmlFor={`check-${i.name}`} >
                                                {i.label}
                                            </label>
                                        </div>;
                                        break;
                                }
                                return <div key={props.url + "-" + ii}>
                                    {el}
                                    <ErrorMessage errors={errors} name={i.name}
                                        render={({ message }) => <p className="text-danger">{message ?? (i.props.required ? "This field is required" : "Validation failed on this field")}</p>} />
                                </div>
                            }) : <div key={props.url + "-single"}>
                                Name: <input {...register("Name", { required: "This field is required" })} className="form-control" autocomplete="off" />
                                <ErrorMessage errors={errors} name="Name"
                                    render={({ message }) => <p className="text-danger">{message}</p>} />

                            </div>
                                
                    }
                    <hr style={{ marginLeft: -15, marginRight: -15 }} />
                    <div style={{ margin: -15, padding: 5 }} className="d-flex justify-content-end">
                        <button className="ro-button">
                            <span>Save</span>
                        </button>
                    </div>
                </form>
        }
        </>
}


export default DynamicAdd;